export default "__VITE_ASSET__CyLLJPl1__"